import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./InviteTeam.css";

const InviteTeam = ({ setAddTeam }) => {
  const [name, setName] = useState("Abraham Benjamin");
  // const [searchByName, setSearchByName] = useState("");

  const [showMenu, setShowMenu] = useState(false);
  const [menu, setMenu] = useState("Team Leader");
  const { orders } = useSelector((state) => state.orderCreate);

  const chooseDropdown = (e) => {
    setMenu(e.target.value);
    setShowMenu(false);
  };

  const handleClose = (e) => {
    if (e.target !== e.currentTarget) return;
    setAddTeam(false);
  };

  useEffect(() => {
    document.onclick = (e) => {
      if (e.target.closest("#add-team") === null) {
        setShowMenu(false);
      }
    };
  }, [orders]);
  return (
    <div className="inviteTeam" onClick={handleClose}>
      <div className="inviteTeam__container">
        <h1>Invite to Team</h1>
        <div className="flex-row">
          <div className="flex-column">
            <span>Team Member</span>
            <input
              type="text"
              placeholder="Name"
              value={name}
              onClick={(e) => setName(e.target.value)}
            />
            <input type="text" placeholder="Search By Name" />
            <div className="inviteTeam__add flex-row">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 12H19"
                  stroke="#077aff"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <path
                  d="M12 19V5"
                  stroke="#077aff"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
              <span>Add More</span>
            </div>
          </div>
          <div>
            <span>Assign Role</span>
            <div className="inviteTeam__dropdownSearch" id="add-team">
              <div
                className={`dropdown-container flex-row ${
                  showMenu && "expand"
                }`}
                onClick={() => setShowMenu((showMenu) => !showMenu)}
              >
                <div className="flex-row">
                  <p>{menu}</p>
                </div>

                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="inviteTeam__dropdownSearchArrow"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 4L8 12L16 20"
                    stroke="black"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div
                className={`dropdown-item-container flex-column ${
                  showMenu && "expand"
                }`}
              >
                <label htmlFor="team-leader" className="flex-row">
                  Team Leader
                  <input
                    type="radio"
                    value="Team Leader"
                    id="team-leader"
                    onClick={chooseDropdown}
                  />
                </label>
                <label htmlFor="team-member" className="flex-row">
                  Team Member (3)
                  <input
                    type="radio"
                    value="Team Member (3)"
                    id="team-member"
                    onClick={chooseDropdown}
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="inviteTeam__btnCotainer flex-row">
          <button className="btn primary">Send Invites</button>
          <button className="btn">
            <svg viewBox="0 0 9 10" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.45455 3.5H6.40909C6.61801 3.5 6.82489 3.53858 7.01791 3.61353C7.21092 3.68849 7.3863 3.79835 7.53403 3.93684C7.68176 4.07534 7.79895 4.23976 7.8789 4.42071C7.95885 4.60167 8 4.79561 8 4.99148C8 5.18734 7.95885 5.38129 7.8789 5.56224C7.79895 5.7432 7.68176 5.90761 7.53403 6.04611C7.3863 6.18461 7.21092 6.29447 7.01791 6.36942C6.82489 6.44438 6.61801 6.48295 6.40909 6.48295H5.45455M3.54545 6.48295H2.59091C2.38199 6.48295 2.17511 6.44438 1.98209 6.36942C1.78908 6.29447 1.6137 6.18461 1.46597 6.04611C1.16761 5.7664 1 5.38704 1 4.99148C1 4.59591 1.16761 4.21655 1.46597 3.93684C1.76432 3.65714 2.16897 3.5 2.59091 3.5H3.54545"
                strokeWidth="0.848485"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.22754 4.99121H5.77299"
                strokeWidth="0.848485"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Copy invite link
          </button>
        </div>
      </div>
    </div>
  );
};

export default InviteTeam;
